/*jshint -W040*/
(function () {
    'use strict';

    angular
        .module('app.region')
        .component('rmapRegionMapDisplay', {
            bindings: {
                map: '<',
                model: '<',
                geodata: '<',
                onStateAdded: '&',
                onStateRemoved: '&'
            },
            controller: regionDisplayController,
            controllerAs: 'vm'
        });

    /* @ngInject */
    function regionDisplayController($scope, leaflet, regionService, utilitiesService) {
        this.$onChanges = onChanges;
        this.$onDestroy = onDestroy;

        var vm = this;
        var geoJsonLayer;
        
        function onChanges(changes) {
            if (changes.geodata) {
                if (vm.map) {
                    geoJsonLayer = leaflet.geoJson(vm.geodata, {
                        style: regionService.getMapStyleOptions(),
                        onEachFeature: onEachFeature
                    }).addTo(vm.map);
                }
            }

            if (changes.model) {
                if (geoJsonLayer) {
                    updateFeatureSelections();   
                }
            }
        }
        
        function onDestroy() {
            clearFeatureSelections();
            geoJsonLayer.clearLayers();
        }

        function clearFeatureSelections() {
            geoJsonLayer.eachLayer(function (layer) {
                layer.feature.properties.selected = false;
            });
        }

        function updateFeatureSelections() {
            geoJsonLayer.eachLayer(function (layer) {
                layer.feature.properties.selected = false;
                angular.forEach(vm.model.states, function (state) {
                    if (layer.feature.properties.STATEID === state.id) {
                        layer.feature.properties.selected = true;
                    }
                });
            });
            redrawFeatures();
        }

        function redrawFeatures() {
            geoJsonLayer.eachLayer(function (layer) {
                if (!layer.feature.properties.selected) {
                    geoJsonLayer.resetStyle(layer);
                } else {
                    layer.setStyle({ fillColor: 'green' });
                }
            });
        }

        function onEachFeature(feature, layer) {
            layer.on('mouseover', function () {
                if (!feature.properties.selected) {
                    setFillColor(layer, true);
                }
            });

            layer.on('mouseout', function () {
                if (!feature.properties.selected) {
                    setFillColor(layer, false);
                }
            });

            layer.on('click', function () {
                if (!feature.properties.selected) {
                    vm.onStateAdded({ state: { id: feature.properties.STATEID, name: feature.properties.NAME } });
                } else {
                    var index = utilitiesService.getIndexOf(vm.model.states, 'id', feature.properties.STATEID);
                    vm.onStateRemoved({ index: index });
                }
                feature.properties.selected = !feature.properties.selected;
                $scope.$apply();
            });
        }

        function setFillColor(layer, isMouseOver) {
            if (isMouseOver) {
                layer.setStyle({ fillColor: '#333' });
            } else {
                layer.setStyle({ fillColor: '#f9f9f9' });
            }

        }
    }

})();
